export default import.meta.ROLLDOWN_FILE_URL_8Av_8NfKYbmM0$Et3J6Emw